import UsersBox from '../../components/admin/UsersBox'
import AdminContentLayout from '../../components/layout/AdminContentLayout'
import AdminLayout from '../../components/layout/AdminLayout'
import CurriculumLayout from '../../components/layout/CurriculumLayout'

const AdminUsers = () => {
  return (
    <AdminLayout>
      <AdminContentLayout>
        <CurriculumLayout title={'Users'}>
          <UsersBox />
        </CurriculumLayout>
      </AdminContentLayout>
    </AdminLayout>
  )
}

export default AdminUsers
